import { useRef, useState } from 'react';
import Avatar from './Avatar';
import Icon from './Icon';
import Sheet from './Sheet';
import { resizeImage } from '../lib/image';
import { useApp } from '../lib/AppContext';

// The profile picture with a camera badge. With a picture there are two choices (new / remove);
// without one, tapping goes straight to the photo picker. Photos are shrunk on the phone first.
export default function AvatarEditor({ name, size = 88 }) {
  const { api, profile, setProfile } = useApp();
  const fileRef = useRef(null);
  const [sheet, setSheet] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const upload = async (event) => {
    const [file] = event.target.files;
    event.target.value = '';
    setSheet(false);
    if (!file) return;
    setBusy(true);
    setError(null);
    try {
      const data = new FormData();
      data.append('photo', await resizeImage(file, 1024));
      const { avatar_url: url } = await api.patch('/avatar', data);
      setProfile((p) => ({ ...p, avatar_url: url }));
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  const remove = async () => {
    setSheet(false);
    setBusy(true);
    try {
      await api.del('/avatar');
      setProfile((p) => ({ ...p, avatar_url: null }));
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col items-center gap-2">
      <button type="button" onClick={() => (profile?.avatar_url ? setSheet(true) : fileRef.current.click())} disabled={busy}
        aria-label="Đổi ảnh đại diện" className="relative">
        <Avatar name={name} url={profile?.avatar_url} size={size} />
        <span className="absolute bottom-0 right-0 grid size-8 place-items-center rounded-full border-2 border-base-100 bg-neutral text-neutral-content">
          {busy ? <span className="loading loading-spinner size-4" /> : <Icon name="camera" className="size-4" />}
        </span>
      </button>
      <input ref={fileRef} type="file" accept="image/*" className="sr-only" tabIndex={-1} onChange={upload} />
      {error && <p role="alert" className="text-sm font-medium text-error">{error}</p>}

      <Sheet open={sheet} onClose={() => setSheet(false)} title="Ảnh đại diện">
        <div className="flex flex-col gap-2">
          <label className="flex min-h-14 cursor-pointer items-center gap-3 rounded-[16px] border border-line px-4 font-semibold">
            <Icon name="photo" className="size-5" /> Chọn ảnh mới
            <input type="file" accept="image/*" className="sr-only" onChange={upload} />
          </label>
          <button type="button" className="flex min-h-14 items-center gap-3 rounded-[16px] border border-line px-4 text-left font-semibold text-error"
            onClick={remove}>
            <Icon name="trash" className="size-5" /> Xóa ảnh
          </button>
        </div>
      </Sheet>
    </div>
  );
}
